const index = () => import('./index');
const list = () => import('./list');

const plantaskRouter = [
  {
    path: '/Plantask/index', name: 'Plantaskindex', component: index, meta: { c: 'plantask', a: 'index' }
  },
  {
    path: '/Plantask/list', name: 'Plantasklist', component: list, meta: { c: 'plantask', a: 'list' }
  },
];

export default plantaskRouter;

